import React, { useEffect, useContext, useState } from "react";
import Text from "../components/Paragraph/Text.js";
import { ConfigContext } from "../App.js";
import { useBlogContent } from "../hooks/useQueries.js";
import { renderCardsSection } from "../functions/renderComponent.js";
import { Helmet } from "react-helmet-async";
import Loading from "../components/Loading/Loading.js";
import { TranslateContext } from "../App.js";

/**
 * Blog page component.
 * Displays all blog posts and featured posts.
 * Uses React Query for cached data fetching.
 */
function Blog() {
  const configuration = useContext(ConfigContext);
  const [featured, setFeatured] = useState(null);
  const [allBlogposts, setAllBlogposts] = useState([]);
  const [isRendering, setIsRendering] = useState(true);
  const language = useContext(TranslateContext).language;

  // Use React Query hook for cached blog data
  const { data: response, isLoading: dataLoading } = useBlogContent();

  useEffect(() => {
    const processBlogData = async () => {
      if (!response) return;
      
      setIsRendering(true);
      
      if (response.blogposts) {
        const blogposts = {
          cardNewsSection: response.blogposts,
          cardType: "blog",
          hasFilter: true,
        };
        setAllBlogposts(await renderCardsSection(blogposts, false, false, language));
      }

      if (response.blog && response.blog.featured) {
        let featuredSection = {
          title: null,
          button: { link: null, size: "medium", text: null },
          cardNewsSection: [],
          cardType: "blog",
          hasFilter: false,
        };
        if (response.blog.featured.title) {
          featuredSection.title = response.blog.featured.title[language];
        }
        if (response.blog.featured.button) {
          if (response.blog.featured.button.link) {
            featuredSection.button.link = response.blog.featured.button.link;
          }
          if (response.blog.featured.button.text) {
            featuredSection.button.text = response.blog.featured.button.text[language];
          }
        }
        if (response.blog.featured.blogposts) {
          featuredSection.cardNewsSection = response.blog.featured.blogposts;
        }
        setFeatured(await renderCardsSection(featuredSection, true, true, language));
      }
      
      setIsRendering(false);
    };

    processBlogData();
  }, [response, language]);

  const pageContent = response;
  const isLoading = dataLoading || isRendering;

  if (isLoading || !pageContent) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>{pageContent.blog?.title[language]}</title>
        <meta name="description" content={pageContent.blog?.metaDescription[language]} />
      </Helmet>
      <div className="row">
        <div className="row-container">
          <div className="column">
            <h1 className="h1-title" style={{ color: configuration.colors.secondary.hex }}>
              {pageContent.blog?.title[language]}
            </h1>
            {pageContent.blog?.onPageDescription && (
              <Text
                content={pageContent.blog?.onPageDescription[language]}
                align={pageContent.blog?.onPageDescription?.justify}
              />
            )}
            {allBlogposts}
            {featured}
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog;
